export const eventTypes = {
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',

  // route actions
  ENTER_ADVANCED: 'Enter - Advanced Scripting step 1',
  ENTER_CREATE: 'Enter - Create Prescription',
  ENTER_EDIT: 'Enter - Edit Prescription',
  ENTER_MANAGE: 'Enter - Script Management',

  // affiliate actions
  CONNECT_TO_AFFILIATE_MYJD: 'myJD --> myJD',

  // advanced actions
  REMOVE_LAYER: 'Confirm Layer Exclusion',
  CANCEL_ADVANCED_FLOW: 'Cancel',
  CHOOSE_SCRIPT_TYPE: 'Select script Type',
  EXCLUDE_YIELD: 'Yield deselect',
  IMPORT_YIELD: 'Import Yield',
  NAVIGATE_ADVANCED_FLOW: 'AutoScript Navigation Click',
  VIEW_ADVANCED_SCREEN: 'AutoScript Page View',
  FINISH_SCRIPT: 'Finish prescription',
  SET_EXCLUDED_LAYERS: 'Layer Exclusion Confirmed',
  SET_HARVEST_CROP: 'Select Harvest Crop',

  // field actions
  SWITCH_FIELD: 'Field Switch',

  // imagery actions
  OVERLAY_DESELECT: 'Baselayer Deselect',
  OVERLAY_SELECT: 'Baselayer Select',

  // planting plan actions
  SET_PLANTING_PLAN_TARGET_YIELD: 'AutoScript Enter Target Yield',
  SET_PLANTING_PLAN_POPULATION: 'AutoScript Enter Population',
  SET_PLANTING_PLAN_PRICE_COMMODITY: 'Enter grain price',
  SET_PLANTING_PLAN_PRICE_PRODUCT: 'Enter seed cost',
  SET_PLANTING_PLAN_GOAL_RATIO: 'Move population slider',
  SET_PLANTING_PLAN_AGRONOMIC_SEASON: 'Select agronomic season',
  UPDATE_PLANTING_PLAN: 'Update prescription',

  // seed selector actions
  SEARCH_SEED_PRODUCTS: 'Hybrid filter',
  NAVIGATE_WINFIELD_R7: 'R7 Click',

  // script/zone actions
  ADD_PIVOT_ZONE: 'Save Shape',
  ADD_POLYGON_ZONE: 'Save Shape',
  ADD_SQUARE_ZONE: 'Save Shape',
  CREATE_SHAPE: 'Create Shape',
  CREATE_SHAPE_DONE: 'Create Shape Completed',
  MERGE_ZONES: 'Merge',
  MERGE_ZONES_DONE: 'Merge Zones Completed',
  SPLIT_ZONE: 'Split',
  SPLIT_ZONE_DONE: 'Split Zone Completed',
  UPDATE_PRODUCT_APPLICATION_PROPERTY: 'Edit Zone Attribute',
  ZONE_HISTORY_POP: 'Undo',

  // uiwidgets actions
  CREATE_SCRIPT: 'Create',
  DELETE_SCRIPT: 'Delete',
  DUPLICATE_SCRIPT: 'Duplicate',
  EDIT_SCRIPT: 'Edit Prescription',
  EXPORT_SCRIPT: 'Export',
  PREVENT_EDIT_SCRIPT: 'Edit Prevent',
  OPEN_SEED_PRODUCT_SELECTOR: 'Hybrid filter open',
  RENAME_SCRIPT: 'Rename',
  SAVE_SCRIPT: 'Save',
  CANCEL_SCRIPT: 'Cancel',
  SET_SCRIPT_PRIMARY: 'Set as Primary',
  SELECT_PRODUCT: 'Product select'
};

export const uiLocations = {
  ADVANCED_PRODUCT_SELECT: 'script-flow',
  ADVANCED_SCREEN_1: 'Select yield maps',
  ADVANCED_SCREEN_1a: 'Import or Basic',
  ADVANCED_SCREEN_2: 'Enter planting plan',
  ADVANCED_SCREEN_3: 'Scenario plan',
  MANUAL_SCREEN_1: 'Select management zones',
  MANUAL_SCREEN_2: 'Enter planting plan',
  LAYER_EXCLUSION: 'Remove Layer',
  CREATE: 'Select script type',
  DOES_NOT_MEET: 'Insufficient yield',
  EXT_DEEP_LINK: 'Deep Link', // came from bookmark
  CLIMATE_DM: 'Data Manager',
  CLIMATE_FIELD_SELECTION: 'Dashboard - Create Rx',
  EDIT: 'Edit Prescription',
  MANAGE: 'Prescription Management',
  MANAGE_OPTIONS_MENU: 'Options menu',
  MANAGE_SCRIPT_NAME: 'Script name click',
  OVERLAY_ARROW_NAVIGATION: 'Arrow navigation',
  OVERLAY_MODAL: 'Overlay Modal',
  OVERLAY_QUICKMAPS: 'Quickmaps',
  PLANTING_PLAN_SCREEN_2: 'Enter planting plan',
  PLANTING_PLAN_SCREEN_3: 'Scenario plan',
  PRODUCT_INPUT: 'autocomplete',
  SEED_PRODUCT_SELECTOR: 'filter',
  CONFIRM_HARVEST_HISTORY: 'Confirm Harvest history'
};

export const HeapActions = {
  CreatePrescriptionInit: 'Script Creator - Create Prescription Init',
  CreatePrescriptionSave: 'Script Creator - Create Prescription Save',
  CreatePrescriptionSaveSuccess: 'Script Creator - Create Prescription Save Success',
};
